import * as _4 from 'lodash4';
import { PlatformUtility } from 'utility-ts-platform';
import { LocationLinkBuilderServant } from '../../../servants/location_link_builder_servant';

interface IMobileWindow extends Window {
  ionic?: any;
}

export class ResourceDetailItemController {
  private hasLocationInfo: boolean;
  private resourceDetail: any;
  private isLocation: boolean = false;
  private isResourceLinkInactive: boolean = false;
  private resourceUrl: string;
  private isMobile: boolean;

  constructor(
    private $window: ng.IWindowService,
    private ResourceLinks: any,
    private utilityConstant: any,
    private locationLinkBuilderServant: LocationLinkBuilderServant,
    private ngEmailManagementService: any
  ) {}

  $onInit() {
    this.refresh();
  }

  $onChanges() {
    this.refresh();
  }

  refresh(): void {
    this.isResourceLinkInactive = this.isLocation && _4.isEmpty(_4.get(this.resourceDetail, 'description.address', ''));
    this.hasLocationInfo = this.resourceDetail ? !_4.isEmpty(this.resourceDetail.description) : false;
    this.resourceUrl = this.resourceDetail.link;
    this.isMobile = PlatformUtility.isMobile();
  }

  isEmail(): boolean {
    return this.resourceDetail.type === this.ResourceLinks.EMAIL;
  }

  openLink() {
    if (this.isEmail()) {
      this.ngEmailManagementService.sendEmail({
        to: _4.get(this.resourceDetail, 'description.value', '')
      });
    } else if (PlatformUtility.isDesktop() || this.resourceDetail.link.indexOf('http') === -1) {
      if (PlatformUtility.isAndroid()) {
        this.$window.open(this.resourceDetail.link, '_system');
      } else {
        this.$window.open(this.resourceDetail.link);
      }
    } else {
      this.$window.open(this.resourceDetail.link, '_blank', this.utilityConstant.APP_BROWSER_ARGUMENTS);
    }
  }

  getCopyText(): string {
    return this.isLocation ? this.locationLinkBuilderServant.getSubURL(this.resourceDetail.description) : '';
  }

  getLabelText(): string {
    //only urls should get a non-empty display attribute, if it exists display it instead
    return this.resourceDetail.description.display
      ? this.resourceDetail.description.display
      : this.resourceDetail.description.value;
  }
}

export class ResourceDetailItemComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-resources/src/components/places/resource_detail_item/resource_detail_item.html';
  public controller: any = ResourceDetailItemController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    resourceDetail: '<',
    isLocation: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/components/places/resource_detail_item/resource_detail_item.ts